<template lang="pug">
.rent-object-features-wrapper
  .button-flex
    .button-wrapper  
      b-button(type="is-primary" @click="showCreateMapModal = true") Karte generieren
    .spacer.md
    .button-wrapper
      b-button(icon-left="download" v-if="parent && parent.id && parent.rentObjectLocations && parent.rentObjectLocations.id" type="is-light" @click="copyFromParent()") Karte vom Haupthaus kopieren
      b-button(icon-left="download" type="is-light" @click="openCopyFromObjectModal()") Karte von anderem Objekt kopieren

  .location-image.margin-top
    img(v-if="formData.url" :src="formData.url")

  b-modal(v-model='showCreateMapModal' destroy-on-hide has-modal-card full-screen trap-focus aria-role='dialog' aria-modal)
    template(#default='props')
      CreateStaticMap(:predata="formData"
                    @close='props.close(); showCreateMapModal = false'
                    @update="(newData) => saveMap(newData)")

  b-modal(v-model="isComponentModalActive"
          has-modal-card
          :full-screen="false" 
          :can-cancel="true")
    .modal-card(style="width: auto")  
      header.modal-card-head
        p.modal-card-title Karte von anderem Objekt kopieren
      section.modal-card-body
        b-table(:data="rentObjectLocations"
                      default-sort-direction="asc"
                      default-sort="date"
                      hoverable)
          b-table-column(field='rentObject.code' label='Code' width='40' sortable centered searchable v-slot="props")
            | {{ props.row.rentObject.code }}
          b-table-column(label='Typ' width='40' sortable, v-slot="props")
            b-field
              b-icon(:icon="props.row.rentObject.rentObjectType.icon")
              p.icon-name {{props.row.rentObject.rentObjectType.name}}
          b-table-column(field='rentObject.name' label='Titel' sortable, v-slot="props")
            | {{ props.row.rentObject.name }}
          b-table-column(label='Aktionen', v-slot="props")
            .button-wrapper
              b-button(type="is-primary" @click="copyFromObject(props.row)") Kopieren
</template>

<script>
import CreateStaticMap from '@/components/molecules/CreateStaticMap.vue';

export default {
  components: {
    CreateStaticMap
  },
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    parentId: {
      type: [Number, String],
      default: null,
    },
    marker: {
      type: Object,
      default() {
        return {lat: null, lng: null}
      },
    }
  },
  data() {
    return {
      isComponentModalActive: false,
      showCreateMapModal: false,
      isModalActive: false,
      parent: null,
      formData: {
        markerLatitude: this.marker.lat,
        markerLongitude: this.marker.lng,
        centerLatitude: this.marker.lat,
        centerLongitude: this.marker.lng,
        bearing: 0.0,
        pitch: 0.0,
        zoom: 15.0
      },
    };
  },
  computed: {
    rentObjectLocations() {
      return this.$store.state.rentObjectLocations.all;
    }
  },
  methods: {
    async saveMap(newData) {
      this.showCreateMapModal = false;
      let loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("rentObjectLocations/create", {
        rentObjectId: this.id,
        ...newData
      });
      this.formData = await this.$store.dispatch("rentObjectLocations/find", {
        rentObjectId: this.id,
      });
      loadingComponent.close()
    },
    copyFromParent() {
      this.formData.markerLatitude = this.parent.rentObjectLocations.markerLatitude;
      this.formData.markerLongitude = this.parent.rentObjectLocations.markerLongitude;
      this.formData.centerLatitude = this.parent.rentObjectLocations.centerLatitude;
      this.formData.centerLongitude = this.parent.rentObjectLocations.centerLongitude;
      this.formData.bearing = this.parent.rentObjectLocations.bearing;
      this.formData.pitch = this.parent.rentObjectLocations.pitch;
      this.formData.zoom = this.parent.rentObjectLocations.zoom;
      this.showCreateMapModal = true;
    },
    copyFromObject(objectData) {
      this.formData.markerLatitude = objectData.markerLatitude;
      this.formData.markerLongitude = objectData.markerLongitude;
      this.formData.centerLatitude = objectData.centerLatitude;
      this.formData.centerLongitude = objectData.centerLongitude;
      this.formData.bearing = objectData.bearing;
      this.formData.pitch = objectData.pitch;
      this.formData.zoom = objectData.zoom;
      this.isComponentModalActive = false;
      this.showCreateMapModal = true;
    },
    async openCopyFromObjectModal() {
      let loadingComponent = this.$buefy.loading.open();
      await this.$store.dispatch("rentObjectLocations/findAll");
      this.isComponentModalActive = true;
      loadingComponent.close()
    }
  },
  async mounted() {
    if (this.parentId) {
      this.parent = await this.$store.dispatch("rentObjects/findOne", { id: this.parentId, noSave: true }); // noSave means that we dont save the rentObject in the store - huge conflict!
      this.parent.rentObjectLocation = await this.$store.dispatch("rentObjectLocations/find", {
        rentObjectId: this.parent.id,
      });
    }
    const data = await this.$store.dispatch("rentObjectLocations/find", {
      rentObjectId: this.id,
    });
    if (data && data.fileId) {
      this.formData = data;
    }
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 13px;
  margin-top: $sm-space;
}

.button-flex, .location-image {
  min-width: 100%;
}
</style>